import React, { useEffect, useState } from "react";
import { View, TouchableOpacity, SafeAreaView, StyleSheet } from "react-native";

import Modal from "./Modal";
import Text from "components/Text";
import Icon from "components/Icon";
import Button from "components/Button";

import { HsvColor } from "react-native-color-picker/dist/typeHelpers";
import { TriangleColorPicker, fromHsv } from "react-native-color-picker";

import { sizes, colors, strings } from "assets/constants";
import { styles } from "./styles";
import { useFlag } from "hooks";
import { mq } from "utils";

export default function ColorPicker(props: ColorPickerT) {
  const { value, onSelect, hideError, error } = props;
  const val = value as string;

  const { flg: modal, on: show, off: hide } = useFlag();

  const [valueState, setValueState] = useState<string | undefined>();

  useEffect(() => {
    setValueState(val);
  }, [val]);

  const _onSelect = (selectedColor: HsvColor) => {
    setValueState(fromHsv(selectedColor));
  };

  const _onConfirm = () => {
    onSelect && onSelect(valueState);
    hide();
  };

  return (
    <>
      <>
        <TouchableOpacity
          onPress={show}
          activeOpacity={sizes.tapOpacity}
          style={{ ...styles.container }}
        >
          <View style={styles.iconContainer}>
            <Icon name="chevron-down" />
          </View>
          <View style={thisStyles.valueContainer}>
            {valueState && (
              <View
                style={{
                  top: mq(4),
                  width: mq(40),
                  height: mq(15),
                  marginLeft: mq(10),
                  marginRight: mq(2),
                  borderRadius: mq(3),
                  backgroundColor: valueState,
                }}
              />
            )}
            <Text
              color={valueState ? colors.textColorDefault : colors.placeholder}
            >
              {valueState || strings.pick_company_color}
            </Text>
          </View>

          <View style={styles.iconContainer}>
            <Icon name="map-pin" />
          </View>
        </TouchableOpacity>

        {!hideError && (
          <View style={styles.errorContainer}>
            <Text size={"xs"} color={colors.danger}>
              {error}
            </Text>
          </View>
        )}
      </>

      <Modal visible={modal} hide={hide} fitHeight>
        <View style={thisStyles.buttonsContainer}>
          <Button
            onPress={hide}
            bgColor={colors.lightButtons}
            circle={mq(45)}
            icon={{ name: "x", color: colors.danger, size: mq(25) }}
          />
          <Text>{strings.set_color}</Text>
          <Button
            onPress={_onConfirm}
            bgColor={colors.lightButtons}
            circle={mq(45)}
            icon={{ name: "check", color: colors.success, size: mq(28) }}
          />
        </View>
        <SafeAreaView style={thisStyles.container}>
          <TriangleColorPicker
            hideSliders
            style={thisStyles.flex}
            defaultColor={valueState}
            onColorChange={(color) => _onSelect(color)}
          />
          <Text
            style={{ marginTop: mq(15) }}
            size={"xl"}
            weight="bold"
            align="center"
          >
            {valueState}
          </Text>

          <Button />
        </SafeAreaView>
      </Modal>
    </>
  );
}

const thisStyles = StyleSheet.create({
  valueContainer: { flex: 1, flexDirection: "row-reverse" },

  container: {
    flex: 1,
    alignSelf: "center",
    paddingHorizontal: "5%",
    justifyContent: "flex-end",
  },

  flex: { width: mq(280), height: mq(400) },

  buttonsContainer: {
    width: "100%",
    height: mq(45),
    flexDirection: "row",
    paddingHorizontal: sizes.space,
    alignItems: "center",
    justifyContent: "space-between",
  },
});
